export default{ 
    api_url : 'https://zsync.zebull.in/invezt'
    }
    // https://zsync.zebull.in/invezt
    //https://zsync.zebull.in
    //http://192.168.5.201:7000